<div *ngIf="isActive" class="so__content" [class.visible]="isActive">
  <ng-content></ng-content>
</div>
